module.exports = __webpack_public_path__ + "789090c77552e23d2981bbcdfd02d2a7.pdf";